<template>
    <div class="signUp" v-if="pageShow">
        <div class="scrollBox">
            <div class="activityMsg">
                <div class="imgBox">
                    <img :src="eventinfo.coveratturlid" alt="">
                </div>
                <div class="textBox">
                    <p class="title">{{eventinfo.title}}</p>
                    <div class="time">{{eventinfo.begintime}}-{{eventinfo.endtime}}</div>
                    <p class="adress">{{eventinfo.address}}</p>
                </div>
            </div>
            <div class="listBox" v-show="ticketlist.length">
                <div v-for="(item, index) in ticketlist" :key="index" class="itemBox">
                    <div class="choiceBox">
                        <van-checkbox v-model="item.check" shape="square" checked-color="#0ABF53"></van-checkbox>
                    </div>
                    <div class="item" @click="oneTicketMsg(item)">
                        <p class="title">{{item.ticketname}}</p>
                        <div class="participant">
                            <p class="left">参加人：</p>
                            <div class="right">
                                <div class="participantItem" v-for="(obj, i) in item.joinnamelist" :key="i">
                                    <p class="name">{{obj.joinername}}</p>
                                    <p class="phoneNum">{{obj.joinermobile}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="ticketNum" v-if="item.ticketnolist.length">
                            <p class="left">票号：</p>
                            <div class="right">
                                <div class="ticketNumItem" v-for="(obj, i) in item.ticketnolist" :key="i">
                                    <p>{{obj.ticketno}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="statusIconBox">
                            <img :src="require('@/common/images/activeTools/ticket_status01.png')" v-if="item.ticketstatus === 30" alt="">
                            <img :src="require('@/common/images/activeTools/ticket_status02.png')" v-if="item.ticketstatus === 1" alt="">
                            <img :src="require('@/common/images/activeTools/ticket_status03.png')" v-if="item.ticketstatus === 32" alt="">
                            <img :src="require('@/common/images/activeTools/ticket_status04.png')" v-if="item.ticketstatus === 3" alt="">
                            <img :src="require('@/common/images/activeTools/ticket_status05.png')" v-if="item.ticketstatus === 31" alt="">
                        </div>
                    </div>
                </div>
            </div>
            <div class="noData" v-if="!ticketlist.length">
                <div class="img">
                    <img :src="require('@/common/images/activeTools/noData.png')" alt="">
                </div>
                <p class="noDataText">您当前没有可签到的票券</p>
                <div class="btnBox">
                    <van-button type="default" @click="checkAtyMsg">查看活动详情</van-button>
                </div>
            </div>
        </div>
        <div style="height: 1rem; background: #F5F7FA"></div>
        <div class="actionBox" v-if="ticketlist.length">
            <van-button type="default" class="allChoice" @click="allChoice">{{allChoiceResult ? '取消全选' : '全选'}}</van-button>
            <van-button type="default" class="signUpbtn" @click="signup" :disabled="!shoiceNum">签到</van-button>
        </div>
        <transition name="slide-sort">
            <aaSignupResult ref="aaSignupResult" @anewSignup="anewSignup" v-if="show" :data="eventinfo"></aaSignupResult>
        </transition>
    </div>
</template>
<script>
import {mapActions} from 'vuex'
import {getEventSignticket, updateEventSignticket} from 'api/activeTools'
import aaSignupResult from '../ticketPage/aaSignupResult'
export default {
    name: 'signUp',
    data() {
        return {
            eventinfo: {
                title: '',
                coveratturlid: '',
                begintime: '',
                endtime: '',
                address: '',
                ticketNumList: [],
                result: '',
                statusname: '',
                status: 0
            },
            ticketlist: [],
            show: false,
            shoiceNum: 0,
            eventid: this.$route.query.eventid ? this.$route.query.eventid : '',
            pageShow: false,
            checkList: [],
            allChoiceResult: false
        }
    },
    mounted() {
        this.getEventSignticket()
    },
    methods: {
        signup() {
            let ticketid = ''
            this.eventinfo.ticketNumList = []
            this.ticketlist.forEach((obj) => {
                if (obj.check) {
                    ticketid += obj.ticketid + ','
                    
                    // this.checkList.push(index)
                }
            })
            if (ticketid.slice(-1) === ',') {
                ticketid = ticketid.substring(0, ticketid.length-1)
            }
            // ticketid += ',589'
            this.setLoading(true)
            updateEventSignticket({
                data: {eventid: this.eventid, ticketid},
                success: data => {
                    this.setLoading(false)
                    let arr = JSON.parse(JSON.stringify(this.ticketlist))
                    // this.eventinfo.statusname = '已签到'
                    this.eventinfo.status = 1
                    data.data.forEach(obj1 => {
                        arr.forEach((obj2, index) => {
                            if (obj1.ticketid === obj2.ticketid) {
                                this.eventinfo.ticketNumList.push(obj2)
                                if (obj1.signstatus === 1) {
                                    obj2.ticketstatusname = '已签到'
                                    obj2.status = 1
                                    // 删除签到成功的数据
                                    this.ticketlist.splice(index, 1)
                                } else {
                                    obj2.ticketstatusname = '签到失败'
                                    obj2.status = 2
                                    this.eventinfo.result = '您有票券签到失败，请重新签到'
                                }
                            }
                        })
                        // this.eventinfo.ticketNumList.forEach(obj2 => {
                        //     if (obj1.ticketid === obj2.ticketid) {
                        //         if (obj1.signstatus === 1) {
                        //             obj2.ticketstatusname = '已签到'
                        //             obj2.status = 1
                        //         } else {
                        //             obj2.ticketstatusname = '签到失败'
                        //             obj2.status = 2
                        //         }
                        //     }
                        // })
                    })
                    // console.log(this.eventinfo.ticketNumList)
                    // this.checkList.forEach(obj => {
                    //     this.ticketlist.splice(obj, 1)
                    // })
                    if (data.data.length) {
                        this.show = true
                    }
                },
                error: data => {
                    this.setLoading(false)
                    // this.eventinfo.result = false
                    // this.show = true
                    // this.eventinfo.statusname = '签到失败'
                    // this.eventinfo.status = 2
                    this.$toast.fail(data.msg)
                }
            })
        },
        anewSignup() {
            this.show = false
            this.eventinfo.ticketNumList = []
        },
        allChoice() {
            if (!this.allChoiceResult) {
                this.allChoiceResult = true
                this.ticketlist.forEach(obj => {
                    obj.check = true
                })
            } else {
                this.allChoiceResult = false
                this.ticketlist.forEach(obj => {
                    obj.check = false
                })
            }
        },
        // 获取代签到列表
        getEventSignticket() {
            this.setLoading(true)
            getEventSignticket({
                data: {eventid: this.eventid},
                success: data => {
                    this.setLoading(false)
                    this.eventinfo.title = data.data.title
                    this.eventinfo.coveratturlid = data.data.coveratturlid
                    this.eventinfo.begintime = data.data.begintime
                    this.eventinfo.endtime = data.data.endtime
                    this.eventinfo.address = data.data.address
                    document.title = this.eventinfo.title
                    data.data.joinlist.forEach(obj => {
                        obj.check = false
                        obj.ticketstatusname = ''
                        obj.status = 0
                        // obj.ticketid = '987'
                    })
                    // this.ticketstatus = data.data.eventinfo.ticketstatus
                    this.ticketlist = data.data.joinlist
                    this.pageShow = true
                },
                error: data => {
                    this.setLoading(false)
                    this.$toast.fail(data.msg)
                }
            })
        },
        oneTicketMsg(item) {
            this.$router.push({name: 'oneTicketDetails', query: {eventid: this.eventid, itemid: item.itemid}})
        },
        checkAtyMsg() {
            this.$router.push({name: 'ActivityDetail', query: {eventid: this.eventid}})
        },
        ...mapActions([
            'setLoading'
        ])
    },
    watch: {
        'ticketlist': {
            handler(newV) {
                let num = 0
                newV.forEach(obj => {
                    if (obj.check) {
                        num++
                    }
                })
                this.shoiceNum = num
            },
            deep: true
        }
    },
    components: {
        aaSignupResult
    }
}
</script>
<style lang="scss">
    .signUp{
        height: 100%;
        display: flex;
        flex-direction: column;
        .scrollBox{
            flex: 1;
            overflow-y: scroll;
            .activityMsg{
                display: flex;
                align-items: center;
                padding: 0.4rem 0.32rem;
                background: #fff;
                margin-bottom: 0.2rem;
                .imgBox{
                    width: 2.6rem;
                    height: 1.6rem;
                    img{
                        width: 2.6rem;
                        height: 1.6rem;
                        border-radius: 0.1rem;
                        box-shadow: 0.01rem 0.05rem 0.05rem #D8D8D8;
                    }
                }
                .textBox{
                    margin-left: 0.2rem;
                    .title{
                        width: 100%;
                        font-size: 0.26rem;
                        line-height: 0.38rem;
                        text-overflow: -o-ellipsis-lastline;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        line-clamp: 2;
                        -webkit-box-orient: vertical;
                        font-weight: bolder;
                    }
                    .time{
                        font-size: 0.2rem;
                        color: #666666;
                        line-height: 0.28rem;
                        margin: 0.08rem 0;
                    }
                    .adress{
                        width: 100%;
                        font-size: 0.2rem;
                        line-height: 0.28rem;
                        text-overflow: -o-ellipsis-lastline;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        line-clamp: 2;
                        -webkit-box-orient: vertical;
                    }
                }
            }
            .refuseReason{
                line-height: 0.4rem;
                background: #FFF7EC;
                color: #FF4747;
                // text-indent: 0.32rem;
                font-size: 0.28rem;
                padding: 0.2rem 0.32rem;
                box-sizing: border-box;
            }
            .listBox{
                padding: 0 0.32rem 0.32rem;
                background: #fff;
                .itemBox{
                    display: flex;
                    align-items: center;
                    .choiceBox{
                        margin-right: 0.32rem;
                        .van-checkbox{
                            width: 0.32rem;
                            height: 0.32rem;
                            .van-checkbox__icon{
                                width: 0.32rem;
                                height: 0.32rem;
                                .van-icon{
                                    width: 0.32rem;
                                    line-height: 0.32rem;
                                    height: 0.32rem;
                                }
                            }
                        }
                    }
                    .item{
                        box-shadow:0px 0.02rem 0.06rem 0px rgba(0,0,0,0.1);
                        border-radius:0.1rem;
                        margin-top: 0.32rem;
                        padding: 0.32rem;
                        position: relative;
                        flex: 1;
                        .title{
                            font-size: 0.28rem;
                            font-weight: 550;
                            padding-bottom: 0.22rem;
                        }
                        .participant, .ticketNum{
                            display: flex;
                            margin-bottom: 0.12rem;
                            color: #666666;
                            .left{
                                width: 1rem;
                                padding-top: 0.05rem;
                            }
                            .right{
                                .participantItem{
                                    display: flex;
                                    .name{
                                        margin-right: 0.2rem;
                                        width: 1rem;
                                        overflow: hidden;
                                        text-overflow: ellipsis;
                                        white-space: nowrap;
                                    }
                                    p{
                                        line-height: 0.4rem;
                                    }
                                }
                                .ticketNumItem{
                                    p{
                                        line-height: 0.4rem;
                                    }
                                }
                            }
                        }
                        .ticketNum{
                            margin-bottom: 0;
                        }
                        .statusIconBox{
                            position: absolute;
                            right: 0;
                            top: 0;
                            img{
                                width: 0.9rem;
                                height: 0.9rem;
                            }
                        }
                    }
                }
                
            }
            .noData{
                padding-top: 1.3rem;
                .img{
                    text-align: center;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    img{
                        width: 3rem;
                        height: 2.5rem;
                    }
                }
                .noDataText{
                    text-align: center;
                    margin-top: 0.6rem;
                    font-size: 0.28rem;
                    color: #999999;
                    line-height: 0.4rem;
                }
                .btnBox{
                    padding: 0.9rem 0.32rem 0;
                    .van-button{
                        width: 100%;
                        height: 0.76rem;
                        background: #fff;
                        line-height: 0.76rem;
                        padding: 0;
                        font-size: 0.3rem;
                        border-radius: 0.4rem;
                        span{
                            color: #333333;
                        }
                    }
                }
            }
        }
        .actionBox{
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            height: 1.1rem;
            background: #fff;
            padding: 0.17rem 0.32rem;
            box-sizing: border-box;
            margin-top: 0.2rem;
            display: flex;
            .signUpbtn{
                flex: 2;
                padding: 0;
                height: 0.76rem;
                line-height: 0.76rem;
                background: linear-gradient(360deg,rgba(10,191,83,1) 0%,rgba(71,236,201,1) 100%);
                color: #fff;
                border-radius: 0.4rem;
                margin-left: 0.32rem;
            }
            .allChoice{
                flex: 1;
                height: 0.76rem;
                line-height: 0.76rem;
                border-radius: 0.4rem;
            }
        }
    }
</style>